import React from "react";

const VoiceInterface = () => {
  return (
    <div>
      <p>Voice interaction will go here.</p>
    </div>
  );
};

export default VoiceInterface;
